import { Component } from '@angular/core';
import { environment } from '@environments/environment';
import { VersionService } from './version.service';
import { CommonModule } from '@angular/common';
import { AccordionModule } from 'primeng/accordion';
import { rotate } from '@shared/animations/rotate.animation';
import { slideToggle } from '@shared/animations/toggle.animation';
import { BadgeModule } from 'primeng/badge';
import { BreadcrumbComponent } from '@shared/components/breadcrumb/breadcrumb.component';
import { AppService } from 'app/app.service';
import { BreadcrumbService } from '@shared/components/breadcrumb/breadcrumb.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-version',
    imports: [
        CommonModule,
        AccordionModule,
        BadgeModule,
        BreadcrumbComponent
    ],
    templateUrl: './version.component.html',
    styleUrl: './version.component.scss',
    animations: [rotate, slideToggle]
})
export class VersionComponent {

  constructor(
    public versionService: VersionService,
    public theme: AppService,
    private breadcrumbService: BreadcrumbService,
    private route: ActivatedRoute,
    private appService: AppService
  ) { }

  knownIssues: any[] = [];
  versionData: any[] = [];
  futureFeatures: any[] = [];
  version = environment.appVersion;

  featuresReadDisabled = false;
  issuesReadDisabled = false;
  versionsReadDisabled = false;

  theme$ = this.appService.theme$;

  ngOnInit(): void {
    const url = location.pathname;
    const breadcrumbLabel = this.route.snapshot.data['breadcrumb'] || 'Version Details';
    this.breadcrumbService.addToBreadcrumbs(url, breadcrumbLabel);

    this.futureFeatures = JSON.parse(localStorage.getItem('logbook.version.data') || '{}').futureFeatures || [];
    this.knownIssues = JSON.parse(localStorage.getItem('logbook.version.data') || '{}').knownIssues || [];
    this.versionData = JSON.parse(localStorage.getItem('logbook.version.data') || '{}').versionData || [];
    this.checkIsNewStatus();
  }

  //Updates the isNew tag of the future feature, known issue, or version
  onGroupItemSelected(groupItem: any, group: string) {
    const aboutData = JSON.parse(localStorage.getItem('logbook.version.data') || '{}');
    groupItem.descriptionShown = !groupItem.descriptionShown;
    if (groupItem.descriptionShown) {
      if (groupItem.isNew) {
        groupItem.isNew = false
        switch (group) {
          case 'feature': 
          aboutData.futureFeatures.filter((f: any) => f.name === groupItem.name)[0].isNew = false;
          break;
          case 'issue':
            aboutData.knownIssues.filter((i: any) => i.name === groupItem.name)[0].isNew = false;
            break;
          case 'version':
            aboutData.versionData.filter((v: any) => v.version === groupItem.version)[0].isNew = false;
            break;
          default:
            break; 
        }
        localStorage.setItem('logbook.version.data', JSON.stringify(aboutData));
          this.versionService.getAboutBadgeValue();
          this.checkIsNewStatus();
      }
    }
  }

  onMarkAllRead(item: string): void {
    const aboutData = JSON.parse(localStorage.getItem('logbook.version.data') || '{}');
    if (item === 'features') {
      aboutData.futureFeatures.forEach((feature: any) => {
        feature.isNew = false;
        this.futureFeatures.forEach((f: any) => {
          f.isNew = false;
          this.checkIsNewStatus();
        });
      });
    } else if (item === 'issues') {
      aboutData.knownIssues.forEach((issue: any) => {
        issue.isNew = false;
        this.knownIssues.forEach((i: any) => {
          i.isNew = false;
          this.checkIsNewStatus();
        });
      });
    } else if (item === 'versions') {
      aboutData.versionData.forEach((version: any) => {
        version.isNew = false;
        this.versionData.forEach((v: any) => {
          v.isNew = false;
          this.checkIsNewStatus();
        });
      });
    }
    localStorage.setItem('logbook.version.data', JSON.stringify(aboutData));
    this.versionService.getAboutBadgeValue();
    this.checkIsNewStatus();
  }

  checkIsNewStatus(): void {
    const aboutData = JSON.parse(localStorage.getItem('logbook.version.data') || '{}');
    this.featuresReadDisabled = aboutData.futureFeatures.every((feature: any) => !feature.isNew);
    this.issuesReadDisabled = aboutData.knownIssues.every((issue: any) => !issue.isNew);
    this.versionsReadDisabled = aboutData.versionData.every((version: any) => !version.isNew);
  }

  versionAccordion = {
    header: {
      color: '{text.color}',
      padding: '0.75rem 1rem',
      fontWeight: '400'
    },
    content: {
      background: 'transparent',
      padding: '0'
    },
    colorScheme: {
      light: {
        header: {
          background: '{surface.0}',
          hoverBackground: '{surface.0}',
          activeBackground: '{surface.0}',
          activeHoverBackground: '{surface.0}',
        }
      },
      dark: {
        header: {
          background: '{surface.50}',
          hoverBackground: '{surface.50}',
          activeBackground: '{surface.50}',
          activeHoverBackground: '{surface.50}',
        }
      }
    }
  }

}
